import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import api, { formatApiError } from "../api";
import AuthLayout from "../components/AuthLayout";
import { Button, Input, Label } from "../components/ui/Primitives";

export default function ResetPasswordPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Passwort aktualisiert. Bitte anmelden.");
      navigate("/login", { replace: true });
    } catch (e2) {
      toast.error(formatApiError(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title={t("auth.reset_title")}
      footer={
        <Link to="/login" data-testid="link-back-to-login" className="text-brand hover:text-brand-hover font-medium">
          ← {t("auth.back_to_login")}
        </Link>
      }
    >
      <form onSubmit={onSubmit} className="space-y-4" data-testid="reset-form">
        <div>
          <Label htmlFor="token">Token</Label>
          <Input id="token" value={token} onChange={(e) => setToken(e.target.value)} required data-testid="reset-token-input" />
        </div>
        <div>
          <Label htmlFor="pwd">{t("common.password")}</Label>
          <Input id="pwd" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} data-testid="reset-password-input" />
        </div>
        <Button type="submit" className="w-full" disabled={loading} data-testid="reset-submit-button">
          {loading ? t("common.loading") : t("auth.submit_reset")}
        </Button>
      </form>
    </AuthLayout>
  );
}
